import { sendMetricAsync } from "@/scripts/helpers/clickTracker";

export const initUploader = () => {
	const fileInput = document.getElementById('fileElem');
	const fileInputLabel = document.querySelector('label[for="fileElem"]');
	const errorCloseButton = document.querySelector('.error-close');
	const uploaderTitle = document.querySelector('#uploader-area__drop-zone .uploader-title');


	function handleTextChanges() {
		if (window.innerWidth < 960) {
			uploaderTitle.innerHTML = 'Tap here to upload documents';
		} else {
			uploaderTitle.innerHTML = 'Drag and drop document here to upload';
		}
	}

	function errorClose() {
		window.errorMessageWindow.style.display = 'none';
	}

	function preventDefaults(e) {
		e.preventDefault()
		e.stopPropagation()
	};

	function setDropEffect(e) {
		e.preventDefault();
		e.stopPropagation();
		e.dataTransfer.effectAllowed = 'copy';
		e.dataTransfer.dropEffect = 'copy';
	}

	function highlight(e) {
		window.dropArea.classList.add('highlight')
	};

	function unhighlight(e) {
		window.dropArea.classList.remove('highlight')
	};

	errorCloseButton.addEventListener('click', errorClose, false);

	['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
		window.dropArea.addEventListener(eventName, preventDefaults, false)
	});

	['dragenter', 'dragover'].forEach(eventName => {
		window.dropArea.addEventListener(eventName, highlight, false)
	});

	['dragleave', 'drop'].forEach(eventName => {
		window.dropArea.addEventListener(eventName, unhighlight, false)
	});

	window.addEventListener('load', handleTextChanges);
	window.addEventListener('resize', handleTextChanges);

	window.dropArea.addEventListener('dragover', setDropEffect, false);

	window.dropArea.addEventListener('drop', (e) => {
		const metrics = {};
		const abTower = fileInputLabel.getAttribute('data-metric-ab-tower') || fileInput.getAttribute('data-metric-ab-tower');
		const dataDog = fileInputLabel.getAttribute('data-metric-data-dog') || fileInput.getAttribute('data-metric-data-dog');

		if (abTower) {metrics.abTower = abTower};
		if (dataDog) {metrics.dataDog = dataDog};
		if (abTower || dataDog) {
			sendMetricAsync(metrics);
		}
		
		handleFileSelect(e);
	}, false);

	fileInput.addEventListener('change', handleFileSelect, false);


	function handleFileSelect(e) {
		preventDefaults(e);
		errorClose();
		const allowedFormats = ['pdf', 'doc', 'docx', 'rtf', 'ppt', 'pptx', 'jpg', 'jpeg', 'png', 'txt'];
		let file;

		if (e.type === 'drop') {
			let dt = e.dataTransfer;
			file = dt.files[0];
		} else if (e.type === 'change') {
			file = e.target.files[0];
		}

		if (file.size > 31 * 1024 * 1024) {
			window.errorFileName.textContent = file.name;
			window.errorText.textContent = 'File size exceeds 31 MB';
			window.errorMessageWindow.style.display = 'block';
			return;
		};

		let fileName = file.name.toLowerCase();
		let fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);

		if (!allowedFormats.includes(fileExtension)) {
			window.errorFileName.textContent = file.name;
			window.errorText.textContent = 'Unsupported file format';
			window.errorMessageWindow.style.display = 'block';
			return;
		};

		uploadFile(file);
	};
};